import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-page-section" }
const _hoisted_2 = { class: "flex flex-row justify-center items-center gap-2 mb-4" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "text-gray-500 text-sm" }
const _hoisted_6 = { class: "gradients" }
const _hoisted_7 = {
  key: 0,
  class: "reviews gap-4 md:gap-5"
}
const _hoisted_8 = { key: 1 }

import { ref, watch } from 'vue'
import { trackClick } from '@/utils/analytics'
import { Review, cachedReviews } from '@/components/cachedReviews'
import { cachedReviews as cachedReviewsEn } from '@/components/cachedReviews-en'
import ReviewCard from './ReviewCard.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Reviews',
  props: {
    placesResponse: {},
    locale: {}
  },
  setup(__props: any) {

const props = __props

const generalRating = ref(5)

const reviews = ref<Review[]>(prepareReviews(cachedReviewsForLocale(props.locale)))

const ratingsCount = ref(reviews.value.length)

function cachedReviewsForLocale(locale: string): Review[] {
    if (locale === 'sl') return cachedReviews
    return cachedReviewsEn
}

watch(
    () => props.placesResponse,
    response => {
        if (!response) return

        if (response.rating) {
            generalRating.value = response.rating
        }
        if (response.reviews) {
            reviews.value = prepareReviews([...cachedReviewsForLocale(props.locale), ...response.reviews])
        }
        if (response.user_ratings_total) {
            ratingsCount.value = response.user_ratings_total
        }
    },
    { immediate: true },
)

watch(
    () => props.locale,
    () => {
        reviews.value = prepareReviews(cachedReviewsForLocale(props.locale))
        if (props.placesResponse?.reviews) {
            reviews.value = prepareReviews([...reviews.value, ...props.placesResponse.reviews])
        }
    },
)

function prepareReviews(reviews: Review[]): Review[] {
    const sorted = reviews.sort((a, b) => b.time - a.time).sort((a, b) => (b.text ? 1 : 0) - (a.text ? 1 : 0))

    const uniqueReviews: Review[] = []
    sorted.forEach(review => {
        if (uniqueReviews.some(r => r.time === review.time)) return
        uniqueReviews.push(review)
    })
    return uniqueReviews
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('reviews.ratingUnit')) + " ", 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(generalRating.value.toFixed(1).replace('.', ',')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(5), (_) => {
          return (_openBlock(), _createElementBlock("svg", {
            class: "star",
            key: _,
            viewBox: "0 0 24 24"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("path", { d: "M12 2l2.7 7.9h8.3l-6.7 4.9 2.7 7.9-6.7-4.9-6.7 4.9 2.7-7.9-6.7-4.9h8.3L12 2z" }, null, -1)
          ]))]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('reviews.reviewsCount', { count: ratingsCount.value })), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (reviews.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (review) => {
              return (_openBlock(), _createBlock(ReviewCard, _mergeProps({
                key: review.time
              }, { ref_for: true }, review, {
                locale: props.locale
              }), null, 16, ["locale"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('reviews.connectionError')), 1)
          ]))
    ]),
    _createVNode(_component_a_button, {
      color: "pale",
      class: "button mt-10 mx-auto",
      target: "_blank",
      href: "https://search.google.com/local/writereview?placeid=ChIJU1Z1b9ZdZEcRs7Vuum1MXBk",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackClick)('write_review')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('reviews.writeReview')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})